import request from '@/api/request'

const url = '/performance'

// 查询所有
export const getAll = () => {
    return request({
        url: url
    })
}